import React from 'react';

export default function ClientPortal({ onRegister, onLogin }) {
  return (
    <div className="client-portal">
      <h2>Monitor your progress... and</h2>
      <p>Optimize your Results!</p>
      <div className="portal-buttons">
        <button
          className="button primary is-medium is-rounded"
          onClick={onRegister}
        >
          Create an Account
        </button>
        <button
          className="button secondary is-medium is-rounded"
          onClick={onLogin}
        >
          Access Your Account
        </button>
      </div>
    </div>
  );
}
